// #region Import - Directives

import { ActionFiltersDirective } from './action-filters/action-filters.directive'
import { ActionRunDirective } from './action-run/action-run.directive'
import { ActionStatusDirective } from './action-status/action-status.directive'
import { AlarmDefinitionsEditDirective } from './alarm-definition/alarm-definitions-edit/alarm-definitions-edit.directive'
import { AlarmsMenuDirective } from './alarms-menu/alarms-menu.directive'
import { ButtonListDirective } from './button-list/button-list.directive'
import { ChangePasswordDirective } from './change-password/change-password.directive'
import { ChangeStatusDirective } from './change-status/change-status.directive'
import { ConfirmationDirective } from './confirmation-popup/confirmation-popup.directive'
import { ConnectedObjectDirective } from './connected-object/connected-object.directive'
import { CookieBannerDirective } from './cookie-banner/cookie-banner.directive'
import { CreateEditPopupDirective } from './create-edit-popup/create-edit-popup.directive'
import { DatatypeLegendDirective } from './datatype-legend/datatype-legend.directive'
import { DatePickerDirective } from './date-picker/date-picker.directive'
import { DetailsParametersDirective } from './details-parameters/details-parameters.directive'
import { DetailsPopupDirective } from './details-popup/details-popup.directive'
import { DeviceConfigurationDirective } from './device-configuration/device-configuration.directive'
import { ExportDirective } from './export/export.directive'
import { FileUploaderDirective } from './file-uploader/file-uploader.directive'
import { FormButtonDirective } from './form-button/form-button.directive'
import { GridAttachmentsEditDirective } from './grid-attachments-edit/grid-attachments-edit.directive'
import { GridButtonDirective } from './grid-button/grid-button.directive'
import { GridDirective } from './grid/grid.directive'
import { GridEditDirective } from './grid-edit/grid-edit.directive'
import { GridSelectDirective } from './grid-select/grid-select.directive'
import { GridSlotEditDirective } from './grid-slot-edit/grid-slot-edit.directive'
import { GroupsEditDirective } from './groups-edit/groups-edit.directive'
import { HeaderDirective } from './header/common.header.directive'
import { HeightFillDirective } from './common.height-fill.directive'
import { HistoryDirective } from './history/history.directive'
import { I18NProvider } from './i18n/common.i18n.provider'
import { InfoPopupDirective } from './info-popup/info-popup.directive'
import { InfoTooltipDirective } from './info-tooltip/info-tooltip.directive'
import { KpiMeasurementsDirective } from './measurements/kpi/kpi.measurements.directive'
import { LayoutDirective } from './layout/common.layout.directive'
import { LoadingIndicatorDirective } from './loading-indicator/common.loading-indicator.directive'
import { LocationSelectDirective } from './location-select/location-select.directive'
import { LoggerService } from './common.logger.service'
import { MeasurementsChartDirective } from './measurements/chart/chart.directive'
import { MeasurementsDirective } from './measurements/measurements.directive'
import { PaymentsDirective } from './payments/payments.directive'
import { PopupScriptDirective } from './popup-script/popup-script.directive'
import { SaveColumnSettingsDirective } from './save-column-settings/save-column-settings.directive'
import { ScheduleDirective } from './schedule/schedule.directive'
import { SchemaDirective } from './schema/schema.directive'
import { SelectAddDescrDirective } from './select-add-descr/select-add-descr.directive'
import { SelectAddFileDirective } from './select-add-file/select-add-file.directive'
import { SelectBoxPopupDirective } from './select-box-popup/select-box-popup.directive'
import { SelectPopoverDirective } from './select-popover/select-popover.directive'
import { SidebarMenuDirective } from './sidebar-menu/common.sidebar-menu.directive'
import { ToolbarPopoverDirective } from './toolbar-popover/toolbar-popover.directive'
import { TreeListDirective } from './tree-list/tree-list.directive'
import { UserMenuDirective } from './user-menu/user-menu.directive'
import { GalleryDirective } from './gallery/gallery.directive'

import { DIRECTIVE_NAME as ELEMENT_SIZE_WATCH_DIRECTIVE_NAME, IMRElementSizeWatchDirective } from './element-size-watch/element-size-watch.directive'

// #endregion

// #region Import - Components

import { COMPONENT_NAME as ACCORDION_COMPONENT_NAME, IMRAccordionComponent } from './accordion/accordion.component'
import { COMPONENT_NAME as ACCORDION_ITEM_COMPONENT_NAME, IMRAccordionItemComponent } from './accordion/components/accordion-item/accordion-item.component'
import { COMPONENT_NAME as BULK_DELETE_COMPONENT_NAME, BulkOperationComponent } from './bulk-operation/bulk-operation.component'
import { COMPONENT_NAME as CHART_COMPONENT_NAME, IMRChartComponent } from './chart/chart.component'
import { COMPONENT_NAME as DATA_TYPE_PANEL_COMPONENT_NAME, IMRDataTypePanelComponent } from './data-type-panel/data-type-panel.component'
import { COMPONENT_NAME as ERRORS_SUMMARY_COMPONENT_NAME, IMRErrorsSummaryComponent } from './errors-summary/errors-summary.component'
import { COMPONENT_NAME as IFRAME_WRAPPER_COMPONENT_NAME, IMRIFrameWrapperComponent } from './iframe-wrapper/iframe-wrapper.component'
import { COMPONENT_NAME as METER_ALARM_DEFINITIONS_COMPONENT_NAME, MeterAlarmDefinitionsComponent } from '../meters/meter-alarm-def/meter-alarm-def.component'
import { COMPONENT_NAME as OVERLAY_CONTAINER_COMPONENT_NAME, IMROverlayContainerComponent } from './overlay-container/overlay-container.component'
import { COMPONENT_NAME as PARAMETERS_COMPONENT_NAME, IMRParametersComponent } from './parameters/parameters.component'
import { COMPONENT_NAME as SELECT_POPOVER_COMPONENT_NAME, IMRSelectPopoverComponent } from './select-popover2/select-popover.component'
import { COMPONENT_NAME as CREATE_RELATED_ITEMS_COMPONENT, CreateRelatedItemsComponent } from './create-related-items/create-related-items.component'

// #endregion

// #region Import - Modules

import { ACTION_RUN_MODULE_NAME } from './action-run'
import { ALARM_DEFINITION_MODULE_NAME } from './alarm-definition'
import { CONFIRMATION_POPUP_MODULE_NAME } from './confirmation-popup2'
import { DEPOSITORY_PARAMETERS_MODULE_NAME } from './depository-parameters'
import { EDIT_GRID_MODULE_NAME } from './edit-grid'
//import { GALLERY_MODULE_NAME } from './gallery'
import { IMAGE_MODULE_NAME } from './image'
import { IMPORT_MODULE_NAME } from './import'
import { ITEM_SWAPPER_MODULE_NAME } from './item-swapper'
import { MAP_MODULE_NAME } from './map2'
import { SELECT_GRID_MODULE_NAME } from './select-grid'
import { SERVICEMAN_MODULE_NAME } from './serviceman'
import { TABS_MODULE_NAME } from './tabs'
import { GRID_DETAILS_MODULE_NAME } from './grid-details/grid-details.module'

// #endregion

// #region Import - Services

import { HistoryService } from './history/history.service'
import { MeasurementsService } from './measurements/measurements.service'
import { DATA_TYPE_GROUP_SERVICE_NAME, DataTypeGroupService } from '../../services/data-type'
import { ERRORS_SUMMARY_SERVICE_NAME, ErrorsSummaryService } from './errors-summary/services'

// #endregion

// #region Import - Other

import { UserSession, IUserSession } from '../../helpers/user-session'

import { CommonHelper } from '../../helpers/common-helper'
import { LocalDictionaryFactory } from '../api/api.local-dictionary.factory'

// #endregion

// #region Module

var moduleName = 'simax.common'
var module = angular.module(moduleName, [
    ACTION_RUN_MODULE_NAME,
    ALARM_DEFINITION_MODULE_NAME,
    CONFIRMATION_POPUP_MODULE_NAME,
    DEPOSITORY_PARAMETERS_MODULE_NAME,
    EDIT_GRID_MODULE_NAME,
    //GALLERY_MODULE_NAME,
    IMAGE_MODULE_NAME,
    IMPORT_MODULE_NAME,
    ITEM_SWAPPER_MODULE_NAME,
    MAP_MODULE_NAME,
    SELECT_GRID_MODULE_NAME,
    SERVICEMAN_MODULE_NAME,
    TABS_MODULE_NAME,
    GRID_DETAILS_MODULE_NAME
])

// #endregion

// #region Directives

module.directive('layout', [() => new LayoutDirective()])
module.directive('heightFill', ['$window', ($window: ng.IWindowService) => new HeightFillDirective($window)])
module.directive('header', [() => new HeaderDirective()])
module.directive('loadingIndicator', ['$http', ($http: ng.IHttpService) => new LoadingIndicatorDirective($http)])
module.directive('sidebarMenu', [() => new SidebarMenuDirective()])
module.directive('createEditPopup', [() => new CreateEditPopupDirective()])
module.directive('locationSelect', [() => new LocationSelectDirective()])
module.directive('selectPopover', [() => new SelectPopoverDirective()])
module.directive('confirmation', [() => new ConfirmationDirective()])
module.directive('gridSelect', [() => new GridSelectDirective()])
module.directive('gridButton', [() => new GridButtonDirective()])
module.directive('measurements', [() => new MeasurementsDirective()])
module.directive('measurementsChart', [() => new MeasurementsChartDirective()])
module.directive('connectedObject', [() => new ConnectedObjectDirective()])
module.directive('history', [() => new HistoryDirective()])
module.directive('gridEdit', [() => new GridEditDirective()])
module.directive('gridSlotEdit', [() => new GridSlotEditDirective()])
module.directive('detailsPopup', [() => new DetailsPopupDirective()])
module.directive('datePicker', [() => new DatePickerDirective()])
module.directive('detailsParameters', [() => new DetailsParametersDirective()])
module.directive('toolbarPopover', [() => new ToolbarPopoverDirective()])
module.directive('userMenu', [() => new UserMenuDirective()])
module.directive('alarmsMenu', [() => new AlarmsMenuDirective()])
module.directive('gridAttachmentsEdit', [() => new GridAttachmentsEditDirective()])
module.directive('changePassword', [() => new ChangePasswordDirective()])
module.directive('saveColumnSettings', [() => new SaveColumnSettingsDirective()])
module.directive('schema', [() => new SchemaDirective()])
module.directive('fileUploader', [() => new FileUploaderDirective()])
module.directive('grid', [() => new GridDirective()])
module.directive('groupsEdit', [() => new GroupsEditDirective()])
module.directive('actionRun', [() => new ActionRunDirective()])
module.directive('actionStatus', [() => new ActionStatusDirective()])
module.directive('actionFilters', [() => new ActionFiltersDirective()])
module.directive('infoTooltip', [() => new InfoTooltipDirective()])
module.directive('infoPopup', [() => new InfoPopupDirective()])
module.directive('treeList', [() => new TreeListDirective()])
module.directive('selectBoxPopup', [() => new SelectBoxPopupDirective()])
module.directive('payments', [() => new PaymentsDirective()])
module.directive('cookieBanner', [() => new CookieBannerDirective()])
module.directive('deviceConfiguration', [() => new DeviceConfigurationDirective()])
module.directive('schedule', [() => new ScheduleDirective()])
module.directive('datatypeLegend', [() => new DatatypeLegendDirective()])
module.directive('selectAddFile', [() => new SelectAddFileDirective()])
module.directive('selectAddDescr', [() => new SelectAddDescrDirective()])
module.directive('popupScript', [() => new PopupScriptDirective()])
module.directive('formButton', [() => new FormButtonDirective()])
module.directive('kpiMeasurements', [() => new KpiMeasurementsDirective()])
module.directive('buttonList', [() => new ButtonListDirective()])
module.directive('selectWithNote', [() => new ChangeStatusDirective()])
module.directive('export', [() => new ExportDirective()])
module.directive('alarmDefinitionsEdit', [() => new AlarmDefinitionsEditDirective()])
module.directive('gallery', [() => new GalleryDirective()])

module.directive(ELEMENT_SIZE_WATCH_DIRECTIVE_NAME, [() => new IMRElementSizeWatchDirective()])

// #endregion

// #region Components

module.component(ACCORDION_COMPONENT_NAME, new IMRAccordionComponent())
module.component(ACCORDION_ITEM_COMPONENT_NAME, new IMRAccordionItemComponent())
module.component(BULK_DELETE_COMPONENT_NAME, new BulkOperationComponent())
module.component(CREATE_RELATED_ITEMS_COMPONENT, new CreateRelatedItemsComponent())
module.component(CHART_COMPONENT_NAME, new IMRChartComponent())
module.component(DATA_TYPE_PANEL_COMPONENT_NAME, new IMRDataTypePanelComponent())
module.component(ERRORS_SUMMARY_COMPONENT_NAME, new IMRErrorsSummaryComponent())
module.component(IFRAME_WRAPPER_COMPONENT_NAME, new IMRIFrameWrapperComponent())
module.component(METER_ALARM_DEFINITIONS_COMPONENT_NAME, new MeterAlarmDefinitionsComponent())
module.component(OVERLAY_CONTAINER_COMPONENT_NAME, new IMROverlayContainerComponent())
module.component(PARAMETERS_COMPONENT_NAME, new IMRParametersComponent())
module.component(SELECT_POPOVER_COMPONENT_NAME, new IMRSelectPopoverComponent())

// #endregion

// #region Module - Factory

module.factory(CommonHelper.Services.history, [
    'localDictionary',
    'userSession',
    (localDictionary: LocalDictionaryFactory, userSession: IUserSession) => new HistoryService(localDictionary, userSession)
]
)

// #endregion

// #region Services

module.service('logger', [() => new LoggerService()])
module.service('measurements', ['$timeout', 'userSession', DATA_TYPE_GROUP_SERVICE_NAME, (
    $timeout: ng.ITimeoutService,
    userSession: IUserSession,
    dataTypeGroupService: DataTypeGroupService
) => new MeasurementsService($timeout, userSession, dataTypeGroupService)])
module.service(ERRORS_SUMMARY_SERVICE_NAME, [() => new ErrorsSummaryService()])
// TODO: MeasurementsService

// #endregion

// #region Providers

module.provider('i18n', [() => new I18NProvider()])
module.provider('userSession', UserSession)

// #endregion

export default moduleName
export { LoggerService }
